import React from 'react';

import ReactDocumentTitle from '../../components/ReactDocumentTitle';
import AppLayout from '../../layouts/AppLayout';
import {AccountContext} from '../../utils/Context';
import CompanyDashboard from '../../components/dashboard/CompanyDashboard';
import AdminDashboard from '../../components/dashboard/AdminDashboard';
import BrandDashboard from '../../components/dashboard/BrandDashboard';

export default function DashboardScene() {

  return (<>
      <ReactDocumentTitle title="Dashboard"/>
      <AppLayout className="">
        <AccountContext.Consumer>
          {account =>
            <div className="pt-5 pb-20">
              {account?.isAdmin() && <AdminDashboard/>}
              {account?.isBrand() && <BrandDashboard/>}
              {!account?.isAdmin() && !account?.isBrand() && <CompanyDashboard/>}
            </div>
          }
        </AccountContext.Consumer>
      </AppLayout>
    </>
  );
}
